import styled from "styled-components";
import {colors} from "nxtconstants";

export const ViewToggleContainer = styled.div`
  display: inline-flex;
  background-color: ${colors.secondary};
  border-radius: 5rem;
  padding: 0.4rem;
  margin-bottom: 2.4rem;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`;

export const ViewToggleButton = styled.button`
  border: none;
  cursor: pointer;
  padding: 0.8rem 2.4rem;
  border-radius: 5rem;
  font-family: "Lato";
  font-size: 1.4rem;
  font-weight: 600;
  background-color: ${(props) => (props.active ? colors.white : "transparent")};
  color: ${(props) => (props.active ? colors.primary : colors.textGray)};
  box-shadow: ${(props) =>
    props.active ? "0 1px 3px rgba(0, 0, 0, 0.08)" : "none"};
  transition: background-color 0.2s ease, color 0.2s ease;

  @media (max-width: 768px) {
    flex: 1;
    text-align: center;
    padding: 1rem;
  }
`;
